import { render, staticRenderFns } from "./ExamConfigurationEditor.vue?vue&type=template&id=834795fe&scoped=true"
import script from "./ExamConfigurationEditor.vue?vue&type=script&lang=js"
export * from "./ExamConfigurationEditor.vue?vue&type=script&lang=js"
import style0 from "./ExamConfigurationEditor.vue?vue&type=style&index=0&id=834795fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834795fe",
  null
  
)

export default component.exports